import styled from 'styled-components';

export const ColumnTitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;

export const ColumnTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-interface-content-normal);
  max-width: 80%;

  &:hover {
    overflow: visible;
    z-index: 1;
  }

  &:hover span {
    background: var(--color-interface-neutral-light);
    border-radius: var(--radius-4);
    padding: calc((var(--spacing-xxs) * 2)) var(--spacing-s);
    margin-left: calc(var(--spacing-s) * -1);
  }
`;

export const ColumnDropdown = styled.div`
  --l-size: 28px;

  position: absolute;
  right: 0;
  visibility: hidden;
  cursor: pointer;
  min-width: var(--l-size);
  width: var(--l-size);
  height: var(--l-size);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-100);

  &:hover {
    color: var(--color-interface-secondary-lighter);
    border: 1px solid var(--color-interface-secondary-lighter);
    background: var(--color-interface-neutral-light);
  }
`;

export const ColumnHeader = styled.td`
  position: relative;
  padding: var(--spacing-m) var(--spacing-l);
  gap: var(--spacing-s);

  &:hover ${ColumnDropdown} {
    visibility: unset;
  }
`;

export const ColumnHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
  height: 100%;
  justify-content: end;
`;

export const ColumnCategory = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: var(--color-interface-content-normal);
`;
